import React, { useRef } from 'react'
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, Radio, RadioGroup, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from 'react-redux';

function CommonDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const handleClose = () => {
   props?.handleClose();
  };
  const radioGroupRef = useRef(null);

  const myRideData = useSelector((state) => state.userTrip?.userTrip?.data);

  const scheduledTime = new Date(myRideData?.scheduledTime);
  const currentTime = new Date();
  // Comparing two dates and converting into hours format (36e5 is definition of 60*60*1000)
  let hrFormat = (scheduledTime.getTime() - currentTime.getTime()) / 36e5;
  const totalMinutes = Math.max(hrFormat * 60, 0);  // Convert hours to minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);
  const timeLeft = `${hours > 0 ? hours + ' hr ' : ''}${minutes > 0 ? minutes + ' min' : ''}`;

  return (
    <div>
     <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props?.open}
        fullScreen={fullScreen}
        fullWidth
        maxWidth={"sm"}
        className="dialogStyle"
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid  md={12} className="width100">
            <DialogTitle
              id="responsive-dialog-title"
              className={`allotDialogHeader ${props?.payment && "paymentHeader"}`}
            >
              <Grid>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  className="iconBtnStyle underline"
                >
                {props?.payment ? <CloseIcon /> : "close"}
                </IconButton>
              </Grid>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                className="marginTop25 settingDialogMain pl20"
              >
                <Grid item alignItems={'center'}>
                  <Typography className={`font20 fontMedium colorPrimary marginBlock10`}>
                    {props?.title ? "Card Authorization" : props?.titleCoupon ? 'Coupons for you' : "Cancel Reason" }
                  </Typography>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent className={`${!props?.payment && "marginLeft20"}`}>
              {props?.cancelReason && 
             <> <Typography gutterBottom className="font18 fontMedium">
                Why do you want to cancel ?
              </Typography>
              <RadioGroup
                ref={radioGroupRef}
                aria-label="ringtone"
                name="ringtone"
                value={props?.value}
                onChange={props?.handleChange}
              >
                {props?.cancelReasonData?.map((option) => (
                  <FormControlLabel
                    value={option.reason}
                    key={option.id}
                    control={<Radio />}
                    label={option.reason}
                  />
                ))}
              </RadioGroup></> }
              {props?.cancelRefund && 
              <>
               <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className="mb20"
              >
                <Grid item>
                  <Typography className="font16">Total Fare</Typography>
                </Grid>
                <Grid item>
                  <Typography className="font16">{"₹" + props?.refundPriceData?.totalAmount}</Typography>
                </Grid>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                className="mb20"
              >
                <Grid item>
                  <Typography className="font16">Cancellation fee</Typography>
                  <Typography className="font12 colorGrey">
                  You are cancelling the ride before {timeLeft}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography className="font16">{"₹" + props?.refundPriceData?.cancellationPrice}</Typography>
                </Grid>
              </Grid>
              <Grid
                item
                container
                justifyContent="space-between"
                alignItems="center"
                className="dashedTopLine"
              >
                <Grid item className="colorBlack fontSemi">
                  <Typography className="font16">Total Refund</Typography>
                </Grid>
                <Grid item className="colorBlack fontSemi">
                  <Typography className="font16">{"₹" + props?.refundPriceData?.refundAmount }</Typography>
                </Grid>
              </Grid>
              <Grid item className="marginTop">
                <Typography
                  gutterBottom
                  className=" colorBlack font18 fontSemi"
                >
                  Are you sure you want to cancel?
                </Typography>
                <Typography className="font12 colorGrey">
                  This trip has been offered to a driver right now, and should
                  be confirmed within seconds.
                </Typography>
              </Grid>
              </>}
              {props?.content && <Typography>{props?.content}</Typography>}
            </DialogContent>
            <DialogActions>
               <Grid
                container
                alignItems="center"
                justifyContent="center"
                className="pb30"
              >
                
                {props?.btn && <Button className="btnAccept" onClick={props?.handleClose}><span className='font20'>OK</span></Button>}
                {props?.cancelReason &&
                <Button
                  autoFocus
                  onClick={props?.handleCancelRefund}
                  className={`buttonEnabled ${
                    !props?.value ? "buttonDisabled" : ""
                  }`}
                  disabled={!props?.value}
                >
                  Cancel Trip
                </Button>}
                {props?.cancelRefund && 
                <>
                 <FormGroup className="filterBox dfDirectionRow">
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="agreeCheckbox"
                        checked={props?.isCheckboxChecked}
                        onChange={props?.handleCheckboxChange}
                      />
                    }
                    label={
                      <Typography className="font14 colorBlack fw400">
                        I have read and agree to the&nbsp; 
                        <a
                          href={"/cancellation-policy"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                        cancellation policy
                        </a>
                      </Typography>
                    }
                  />
                </FormGroup>

                <Button
                  variant="contained"
                  size="medium"
                  className={`buttonEnabled ${
                    !props?.isCheckboxChecked ? "buttonDisabled" : ""
                  }`}
                  type="submit"
                  fullWidth
                  disabled={!props?.isCheckboxChecked}
                  onClick={props?.onClickCancel}
                >
                  Cancel Trip
                </Button></>
                }
              </Grid> 
              
            </DialogActions>
          </Grid>
        </Grid>
      </Dialog> 
    </div>
  )
}

export default CommonDialog
